export enum TransferStatus {
  applicationSent = 'Application Sent',
  applicationViewed = 'Application Viewed',
}

export const TransferExpiresInDays = 30;
